var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04495 4.25H4.87188C4.48244 4.25 4.16675 4.6231 4.16675 5.08333V8.83333C4.16675 9.29357 4.48244 9.66667 4.87188 9.66667H8.04495C8.43438 9.66667 8.75008 9.29357 8.75008 8.83333V5.08333C8.75008 4.6231 8.43438 4.25 8.04495 4.25Z",
    stroke: "#0869FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.75004H2.08333C1.86232 6.75004 1.65036 6.66224 1.49408 6.50596C1.3378 6.34968 1.25 6.13772 1.25 5.91671V2.16671C1.25 1.94569 1.3378 1.73373 1.49408 1.57745C1.65036 1.42117 1.86232 1.33337 2.08333 1.33337H5C5.22101 1.33337 5.43297 1.42117 5.58926 1.57745C5.74554 1.73373 5.83333 1.94569 5.83333 2.16671V2.58337",
    stroke: "#0869FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAd);
export default __webpack_public_path__ + "static/media/copy_ad.e5e1cee6502c021f39087b6dcaf8560f.svg";
export { ForwardRef as ReactComponent };